import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Stack,
    Avatar,
} from "@mui/material";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import SchoolIcon from "@mui/icons-material/School";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import TrendingDownRoundedIcon from "@mui/icons-material/TrendingDownRounded";

import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/logo.png";

const reportTypeMap = {
    monthly: {
        label: "MIESIĘCZNY",
        icon: <CalendarMonthIcon />,
        color: "#55c6d0",
    },
    quarter: {
        label: "KWARTALNY",
        icon: <CalendarTodayIcon />,
        color: "#8c96e8",
    },
    vr: {
        label: "VR",
        icon: <SportsEsportsIcon />,
        color: "#c77bea",
    },
    training: {
        label: "SZKOLENIE",
        icon: <SchoolIcon />,
        color: "#a97bea",
    },
};

export default function UserStatsCardWeb({ report, reports }) {
    const [engagementChange, setEngagementChange] = useState(null);

    const navigate = useNavigate();

    console.log('report', report)
    console.log('reports', reports)

    const reportConfig =
        reportTypeMap[report?.type] || reportTypeMap.monthly;

    const reportBgColor = {
        monthly: "#164d55",
        quarter: "#252e5e",
        vr: "#3b123f",
        training: "#35105f",
    }[report?.type] || "#294e6b";

    const sortedReports = Array.isArray(reports)
        ? [...reports]
            .filter((r) => r?.createdAt)
            .sort(
                (a, b) =>
                    new Date(b.createdAt) - new Date(a.createdAt)
            )
        : [];

    const currentIndex = sortedReports.findIndex(
        (r) => r.id === report.id
    );

    const lastReports =
        currentIndex !== -1
            ? sortedReports.slice(currentIndex + 1, currentIndex + 4)
            : [];

    const calculateReportTotal = (rep) => {
        if (!rep?.vrData) return 0;

        return rep.vrData.reduce((sum, data) => {
            const poziomyValues = Object.values(
                data?.poziomy ?? {}
            );

            const total = poziomyValues.reduce(
                (acc, arr) =>
                    acc + (Array.isArray(arr) ? arr.length : 0),
                0
            );

            return sum + total;
        }, 0);
    };

    useEffect(() => {
        if (!report || !lastReports?.length) return;

        const currentTotal = calculateReportTotal(report);
        const previousTotal = calculateReportTotal(lastReports[0]);

        if (previousTotal > 0) {
            const change =
                ((currentTotal - previousTotal) / previousTotal) * 100;

            setEngagementChange(change);
        } else {
            setEngagementChange(0);
        }
    }, [report, lastReports]);

    return (
        <Card
            elevation={0}
            sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: "24px",
                color: "#fff",
                background: `
                    radial-gradient(
                        circle at 85% 15%,
                        ${reportConfig.color}30 0%,
                        transparent 32%
                    ),
                    radial-gradient(
                        circle at 15% 100%,
                        rgba(255,255,255,0.06) 0%,
                        transparent 35%
                    ),
                    linear-gradient(
                        135deg,
                        ${reportBgColor} 0%,
                        ${reportBgColor}ee 55%,
                        #102c3d 100%
                    )
                `,
                border: "1px solid rgba(255,255,255,0.08)",
                boxShadow: "0 12px 35px rgba(0,0,0,0.16)",
                transition: "all 0.3s ease",

                "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 18px 45px rgba(0,0,0,0.22)",
                },
            }}
        >
            {/* <Typography
                sx={{
                    position: "absolute",
                    right: "-10px",
                    bottom: "-45px",
                    fontSize: "180px",
                    lineHeight: 1,
                    fontWeight: 900,
                    color: "rgba(255,255,255,0.035)",
                    userSelect: "none",
                    pointerEvents: "none",
                }}
            >
                {report?.id}
            </Typography> */}

            <Box
                sx={{
                    position: "absolute",
                    right: "-80px",
                    top: "-80px",
                    width: 230,
                    height: 230,
                    borderRadius: "50%",
                    border: `1px solid ${reportConfig.color}25`,
                    boxShadow: `0 0 80px ${reportConfig.color}15`,
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    right: "-40px",
                    top: "-40px",
                    width: 150,
                    height: 150,
                    borderRadius: "50%",
                    border: `1px solid ${reportConfig.color}18`,
                }}
            />

            <CardContent
                sx={{
                    position: "relative",
                    zIndex: 2,
                    p: { xs: 2.5, md: 3 },
                    "&:last-child": {
                        pb: { xs: 2.5, md: 3 },
                    },
                }}
            >
                {/* HEADER */}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={3}
                >
                    <Stack spacing={0.4}>
                        <Typography
                            variant="caption"
                            sx={{
                                color: "rgba(255,255,255,0.55)",
                                letterSpacing: 1.2,
                                textTransform: "uppercase",
                                fontWeight: 600,
                            }}
                        >
                            Raport
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                color: "rgba(255,255,255,0.85)",
                                fontWeight: 500,
                            }}
                        >
                            {dayjs(report?.createdAt).format(
                                "DD.MM.YYYY • HH:mm"
                            )}
                        </Typography>
                    </Stack>

                    {engagementChange !== null && (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.7,
                                px: 1.3,
                                py: 0.7,
                                borderRadius: "50px",
                                backgroundColor:
                                    engagementChange >= 0
                                        ? "rgba(76,175,80,0.13)"
                                        : "rgba(211,83,79,0.13)",
                                border: `1px solid ${engagementChange >= 0
                                    ? "rgba(76,175,80,0.22)"
                                    : "rgba(211,83,79,0.22)"
                                    }`,
                            }}
                        >
                            {engagementChange >= 0 ? (
                                <TrendingUpRoundedIcon
                                    sx={{
                                        fontSize: 17,
                                        color: "#72d77a",
                                    }}
                                />
                            ) : (
                                <TrendingDownRoundedIcon
                                    sx={{
                                        fontSize: 17,
                                        color: "#ff8581",
                                    }}
                                />
                            )}

                            <Typography
                                variant="caption"
                                sx={{
                                    fontWeight: 700,
                                    color:
                                        engagementChange >= 0
                                            ? "#72d77a"
                                            : "#ff8581",
                                }}
                            >
                                {Math.abs(engagementChange).toFixed(1)}%
                            </Typography>
                        </Box>
                    )}
                </Box>

                <Box
                    display="flex"
                    alignItems="center"
                    gap={3}
                    sx={{
                        flexDirection: {
                            xs: "column",
                            sm: "row",
                        },
                        alignItems: {
                            xs: "flex-start",
                            sm: "center",
                        },
                    }}
                >
                    {/* LOGO */}
                    <Box
                        sx={{
                            width: { xs: "100%", sm: 170 },
                            height: 100,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "18px",
                            background:
                                "rgba(255,255,255,0.055)",
                            border:
                                "1px solid rgba(255,255,255,0.08)",
                            backdropFilter: "blur(10px)",
                        }}
                    >
                        <img
                            src={Logo}
                            alt="Logo"
                            style={{
                                maxWidth: "140px",
                                maxHeight: "70px",
                                objectFit: "contain",
                            }}
                        />
                    </Box>

                    <Box flex={1}>
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            mb={0.5}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    letterSpacing: "-0.3px",
                                }}
                            >
                                Raport #{report?.id}
                            </Typography>

                            <Box
                                sx={{
                                    width: 7,
                                    height: 7,
                                    borderRadius: "50%",
                                    backgroundColor:
                                        reportConfig.color,
                                    boxShadow: `0 0 10px ${reportConfig.color}`,
                                }}
                            />
                        </Stack>

                        <Typography
                            variant="body2"
                            sx={{
                                color: "rgba(255,255,255,0.55)",
                                mb: 2,
                            }}
                        >
                            {report?.reportType}
                        </Typography>

                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            useFlexGap
                        >
                            <BadgeWeb
                                color="#D4AF37"
                                value={
                                    report?.reportData
                                        ?.earnedCredsGold ?? 0
                                }
                                label="Złote"
                            />

                            <BadgeWeb
                                color="#C0C0C0"
                                value={
                                    report?.reportData
                                        ?.earnedCredsSilver ?? 0
                                }
                                label="Srebrne"
                            />

                            <BadgeWeb
                                color="#CD7F32"
                                value={
                                    report?.reportData
                                        ?.earnedCredsBronze ?? 0
                                }
                                label="Brązowe"
                            />
                        </Stack>
                    </Box>
                </Box>

                <Box
                    mt={3}
                    pt={2}
                    sx={{
                        borderTop:
                            "1px solid rgba(255,255,255,0.08)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        sx={{
                            color: reportConfig.color,
                        }}
                    >
                        <Avatar
                            sx={{
                                width: 34,
                                height: 34,
                                backgroundColor: `${reportConfig.color}18`,
                                color: reportConfig.color,
                            }}
                        >
                            {React.cloneElement(
                                reportConfig.icon,
                                {
                                    fontSize: "small",
                                }
                            )}
                        </Avatar>

                        <Typography
                            variant="caption"
                            sx={{
                                fontWeight: 700,
                                letterSpacing: 1,
                                color: "rgba(255,255,255,0.7)",
                            }}
                        >
                            {reportConfig.label}
                        </Typography>
                    </Stack>

                    <Box
                        onClick={() =>
                            navigate(`/report/${report.id}`)
                        }
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            cursor: "pointer",
                            px: 1.5,
                            py: 0.8,
                            borderRadius: "10px",
                            color: "#fff",
                            backgroundColor:
                                "rgba(255,255,255,0.06)",
                            border:
                                "1px solid rgba(255,255,255,0.08)",
                            transition: "all 0.2s ease",

                            "&:hover": {
                                backgroundColor:
                                    "rgba(255,255,255,0.12)",
                                gap: 1,
                            },
                        }}
                    >
                        <Typography
                            variant="caption"
                            sx={{ fontWeight: 600 }}
                        >
                            Zobacz szczegóły
                        </Typography>

                        <ArrowForwardRoundedIcon
                            sx={{ fontSize: 17 }}
                        />
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
}

function BadgeWeb({ color, value, label }) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={0.7}
            sx={{
                px: 1.2,
                py: 0.65,
                borderRadius: "10px",
                backgroundColor: "rgba(255,255,255,0.055)",
                border: "1px solid rgba(255,255,255,0.07)",
            }}
        >
            <EmojiEventsIcon
                sx={{
                    color,
                    fontSize: 19,
                    filter: `drop-shadow(0 0 4px ${color}55)`,
                }}
            />

            <Typography
                sx={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 14,
                }}
            >
                {value}
            </Typography>

            <Typography
                sx={{
                    color: "rgba(255,255,255,0.42)",
                    fontSize: 11,
                }}
            >
                {label}
            </Typography>
        </Stack>
    );
}



// import React, { useEffect, useState } from "react";
// import { Card, CardContent, Typography, Box, Stack, Avatar } from "@mui/material";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
// import SchoolIcon from '@mui/icons-material/School';
// import dayjs from "dayjs";
// // import ReportsTrendWeb from "./ReportsTrendWeb";
// import BadgeIcon from "@mui/icons-material/EmojiEvents";
// import { useNavigate } from "react-router-dom";
// import Logo from "../../assets/logo.png";


// const reportTypeMap = {
//     monthly: { label: "miesięczny", icon: <CalendarMonthIcon fontSize="large" /> },
//     quarter: { label: "kwartalny", icon: <CalendarTodayIcon fontSize="large" /> },
//     vr: { label: "za VR", icon: <SportsEsportsIcon fontSize="large" /> },
//     training: { label: "za szkolenie", icon: <SchoolIcon fontSize="large" /> },
// };

// const lightenHex = (hex, amount = 0.2) => {
//     if (!hex) return hex;
//     hex = hex.replace("#", "");
//     if (hex.length === 8) hex = hex.substring(0, 6);
//     const num = parseInt(hex, 16);
//     let r = Math.min(255, ((num >> 16) + 255 * amount) | 0);
//     let g = Math.min(255, (((num >> 8) & 0xff) + 255 * amount) | 0);
//     let b = Math.min(255, ((num & 0xff) + 255 * amount) | 0);
//     return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
// };

// export default function UserStatsCardWeb({ report, reports }) {
//     const [engagementChange, setEngagementChange] = useState(null);

//     const navigate = useNavigate()

//     const reportBgColor = {
//         monthly: "#1e6169",
//         quarter: "#2d376d",
//         vr: "#471047",
//         training: "#43127bff",
//     }[report?.type];

//     const sortedReports = Array.isArray(reports)
//         ? [...reports].filter(r => r?.createdAt).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
//         : [];

//     const currentIndex = sortedReports.findIndex(r => r.id === report.id);
//     const lastReports = currentIndex !== -1 ? sortedReports.slice(currentIndex + 1, currentIndex + 4) : [];

//     const calculateReportTotal = rep => {
//         if (!rep?.vrData) return 0;
//         return rep.vrData.reduce((sum, data) => {
//             const poziomyValues = Object.values(data?.poziomy ?? {});
//             const total = poziomyValues.reduce(
//                 (acc, arr) => acc + (Array.isArray(arr) ? arr.length : 0),
//                 0
//             );
//             return sum + total;
//         }, 0);
//     };

//     useEffect(() => {
//         if (!report || !lastReports?.length) return;
//         const currentTotal = calculateReportTotal(report);
//         const previousTotal = calculateReportTotal(lastReports[0]);
//         if (previousTotal > 0) {
//             const change = ((currentTotal - previousTotal) / previousTotal) * 100;
//             setEngagementChange(change);
//         } else setEngagementChange(0);
//     }, [report, lastReports]);

//     return (
//         <Card sx={{ backgroundColor: reportBgColor, borderRadius: 3, mb: 0, position: "relative", color: "#fff" }}>
//             <CardContent>
//                 <Box display="flex" justifyContent="space-between" mb={1}>
//                     <Typography variant="subtitle1">{dayjs(report?.createdAt).format("YYYY-MM-DD HH:mm")}</Typography>
//                     {engagementChange !== null && (
//                         <Typography variant="body2" sx={{ color: engagementChange >= 0 ? "#4CAF50" : "#d9534f" }}>
//                             {engagementChange >= 0 ? "↑" : "↓"} {Math.abs(engagementChange).toFixed(1)}% od ostatniego raportu
//                         </Typography>
//                     )}
//                 </Box>

//                 <Box display="flex" alignItems="center">
//                     <Box width={180} height={90}>
//                         {/* <ReportsTrendWeb report={report} lastReports={lastReports} /> */}
//                         <img
//                             src={Logo}
//                             alt="Logo"
//                             // style={{ maxWidth: "40px", marginRight: "30px" }}
//                             style={{ maxWidth: "160px", marginRight: "10px" }}
//                         />
//                     </Box>
//                     <Box ml={4} flex={1}>
//                         <Typography variant="body1">Raport nr {report?.id}</Typography>
//                         <Typography variant="body2">{report?.reportType}</Typography>
//                         <Stack direction="row" spacing={1} mt={1}>
//                             <BadgeWeb color="#D4AF37" value={report?.reportData?.earnedCredsGold ?? 0} />
//                             <BadgeWeb color="#C0C0C0" value={report?.reportData?.earnedCredsSilver ?? 0} />
//                             <BadgeWeb color="#CD7F32" value={report?.reportData?.earnedCredsBronze ?? 0} />
//                         </Stack>
//                     </Box>
//                 </Box>

//                 <Box mt={2} textAlign="right">
//                     <Typography
//                         sx={{ cursor: "pointer", textDecoration: "underline" }}
//                         onClick={() => navigate(`/report/${report.id}`)}
//                     >
//                         Zobacz szczegóły →
//                     </Typography>
//                 </Box>

//                 <Typography sx={{ position: "absolute", right: 16, top: 36, color: lightenHex(reportBgColor, 0.4) }}>
//                     {reportTypeMap[report?.type]?.label}
//                 </Typography>
//                 <Box sx={{ position: "absolute", right: 16, bottom: 48 }}>{reportTypeMap[report?.type]?.icon}</Box>
//             </CardContent>
//         </Card>
//     );
// }

// function BadgeWeb({ color, value }) {
//     return (
//         <Stack direction="row" spacing={0.5} alignItems="center" sx={{ bgcolor: "#365b77", px: 1, py: 0.5, borderRadius: 1 }}>
//             <BadgeIcon sx={{ color, fontSize: 18 }} />
//             <Typography sx={{ color, fontWeight: 600 }}>{value}</Typography>
//         </Stack>
//     );
// }
